
export const arrow = `<svg xmlns="http://www.w3.org/2000/svg" width="22.908" height="15.811" viewBox="0 0 22.908 15.811">
  <g id="Group_243" data-name="Group 243" transform="translate(0 0.746)">
    <line id="Line_25" data-name="Line 25" x2="20" transform="translate(0 7.6)" fill="none" stroke="#fff" stroke-width="2"/>
    <path id="Path_2086" data-name="Path 2086" d="M546,171.4l8.667,7.745L546,185.667" transform="translate(-533.333 -171.4)" fill="none" stroke="#fff" stroke-width="2"/>
  </g>
</svg>
`;


// WEBPACK FOOTER //
// ./scripts/util/svgs.js